/*=====================================
    選擇其他規格

    Author: Gray
    CreateTime: 2018 / 12 / 07
=====================================*/
window.InifECMobileApp.directive('selectCount', ['$ngModal',
	function ($ngModal) {

		var _dir = {};

		var controller = ['$scope', function($scope) {

            // ------------------------------
            // 開啟 modal
            // ------------------------------
            var openModal = function() {

            	$ngModal.openModal('select-more-options-modal');
            }

            // ------------------------------
            // 關閉 modal
            // ------------------------------
            var closeModal = function() {

                $scope.hasHtml = false;
            	$ngModal.closeModal('select-more-options-modal');
            }

            // ------------------------------
            // isOptionActive
            // ------------------------------
            var isOptionActive = function(option) {

                if($scope._isOptionActive) {
                    return $scope._isOptionActive(option);
                }

                return undefined;
            }

            // ------------------------------
            // getOptionString
            // ------------------------------
            var getOptionString = function(option) {

                if($scope._getOptionString) {
                    return $scope._getOptionString(option);
                }

                return undefined;
            }

            // ------------------------------
            // getOptionHtmlString
            // ------------------------------
            var getOptionHtmlString = function(option) {

                if($scope._getOptionHtmlString) {
                    return $scope._getOptionHtmlString(option);
                }

                return undefined;
            }

            // ------------------------------
            // onOptionsClick
            // ------------------------------
            var onOptionsClick = function(option) {

                $scope._onOptionsClick && $scope._onOptionsClick(option, true);
                closeModal();
            }

            /*--------------------------
                Events
            --------------------------*/
            $scope.$on('OPEN_SELECT_MORE_OPTIONS_MODAL', function(event, data) {

                if(data) {
                    $scope.hasHtml = data.hasHtml;
                    $scope.options = data.options;
                    $scope._isOptionActive = data.isOptionActive;
                    $scope._getOptionString = data.getOptionString;
                    $scope._getOptionHtmlString = data.getOptionHtmlString;
                    $scope._onOptionsClick = data.onOptionsClick;
                    
                    openModal();
                }
            });

            /*--------------------------
                Members
            --------------------------*/
            $scope.hasHtml = false;
            $scope.options = [];

            /*--------------------------
                Methods
            --------------------------*/
            $scope._isOptionActive;
            $scope._getOptionString;
            $scope._getOptionHtmlString;
            $scope._onOptionsClick;
            $scope.isOptionActive = isOptionActive;
            $scope.getOptionString = getOptionString;
            $scope.getOptionHtmlString = getOptionHtmlString;
            $scope.onOptionsClick = onOptionsClick;
		}]

		_dir.restrict = "E";
		_dir.scope = true;
		_dir.templateUrl = "mobile/partials/modal/select_count.html";
		_dir.controller = controller;

		return _dir;
	}]
);